import React, { FC } from 'react';
import { CustomerInfoProps } from './CustomerInfoProps';
import './CustomerInfo.scss';
import { useNavigate } from 'react-router';
import { resetCustomerList } from '../../../../slices/customerListSlice/customerListSlice';
import { resetCustomer } from '../../../../slices/customerSlice/customerSlice';
import {
  resetDiscount,
  resetMordy,
  resetNote,
  resetOrder,
  resetVoucher,
} from '../../../../slices/orderSlice/orderSlice';
import { resetItems } from '../../../../slices/itemsSlice/itemsSlice';
import { resetLineItems } from '../../../../slices/lineItemsSlice/lineItemsSlice';
import { useDispatch } from 'react-redux';

const CustomerInfo: FC<CustomerInfoProps> = ({ customer }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formatPhone = phoneNumber => phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

  const handleClick = () => {
    dispatch(resetCustomerList());
    dispatch(resetOrder());
    dispatch(resetItems());
    dispatch(resetLineItems());
    dispatch(resetNote());
    dispatch(resetVoucher());
    dispatch(resetDiscount());
    dispatch(resetMordy());
    navigate(`/customer?id=${customer.id}`);
  };

  return (
    <div className="customer-info" onClick={handleClick}>
      <div className="name">{`${customer.firstName} ${customer.lastName}`}</div>
      <div>{formatPhone(customer.phoneNumber)}</div>
      <div>{customer.email}</div>
    </div>
  );
};

export default CustomerInfo;
